import { Component, OnInit, Input } from '@angular/core';
import { ControlBase } from "../control-base";
import { UntypedFormGroup } from '@angular/forms';
import { ControlService } from "../../services/control.service";

@Component({
    selector: 'app-control',
    templateUrl: './control.component.html',
    styleUrls: ['./control.component.scss'],
    standalone: false
})
export class ControlComponent implements OnInit {

  @Input() control!: ControlBase<string>;
  @Input() form!: UntypedFormGroup;
  options: any[] = [];

  constructor(
    private controlService: ControlService
  ) {

  }

  ngOnInit(): void {
    let getDropdownOptionsRequest: any = null;

    if (
      this.control.options
      &&
      this.control.controlType === "dropdown"
    ) {
      getDropdownOptionsRequest = this
        .controlService
        .getDropdownOptions(this.control.options)

      if (getDropdownOptionsRequest)
        getDropdownOptionsRequest
          .subscribe((options: any[]) => {
            this.options = options;
          })
    }
  }

  get isValid() { return this.form.controls[this.control.key].valid; }
}
